import { render } from "./EditDrivers.vue?vue&type=template&id=2fceddae&ts=true"
import script from "./EditDrivers.vue?vue&type=script&lang=ts"
export * from "./EditDrivers.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__